export default __webpack_public_path__ + "static/media/Baby35.f8fb9d17.gif";